<!-- Top nav-->
<gx-toast></gx-toast>
<gx-dialog></gx-dialog>
<gx-drawer-blocking></gx-drawer-blocking>

<hoc-yesnodialog dialogId="custom"></hoc-yesnodialog>

<header class="border-ui-border bg-ui-surface-rise relative flex items-center border-b" data-testid="header">
  <!-- Logo area -->
  <gx-brand data-testid="header-logo">Maps-v3 ({{ applicationConfigurationService.version }})</gx-brand>
  <div class="mx-4 flex flex-1 items-center justify-end gap-3">
    <!-- Search area -->

    <hoc-download-status></hoc-download-status>

    <div class="hidden sm:block">
      <div class="flex items-center gap-3">
        <template [ngTemplateOutlet]="userMenu"></template>
        <template [ngTemplateOutlet]="appearanceMenu"></template>
      </div>
    </div>

    <!-- Mobile menu button -->
    <div class="inline-flex lg:hidden">
      <gx-button
        data-testid="open-menu-button"
        text="Open main menu"
        variant="neutral"
        icon="bars"
        hasIcon="only"
        (click)="toggleOffCanvasMenu()" />
    </div>
  </div>
</header>

<!-- Mobile menu, show/hide this div based on menu open/closed state -->
@if (isOffCanvasMenuDialog) {
  <div class="z-40 lg:hidden" [ngClass]="isOffCanvasMenu ? 'absolute inset-0' : 'relative w-0 h-0'" role="dialog" aria-modal="true">
    @if (isOffCanvasMenu) {
      <div @opacity class="absolute inset-0 bg-black/60"></div>
      <div @opacityScaleUp (click)="toggleOffCanvasMenu()" class="fixed inset-0 z-40 sm:hidden">
        <div
          class="bg-ui-surface-rise fixed inset-0 z-40 flex size-full flex-col sm:inset-y-0 sm:left-auto sm:right-0 sm:w-full sm:max-w-sm sm:shadow-lg"
          aria-label="Global">
          <div class="flex items-center justify-between">
            <!-- Logo area -->
            <gx-brand />
            <div class="ml-auto mr-4 inline-flex items-center justify-center">
              <gx-button
                data-testid="close-menu-button"
                text="Close main menu"
                variant="neutral"
                icon="close"
                hasIcon="only"
                (click)="toggleOffCanvasMenu()" />
            </div>
          </div>
          <!-- menu -->
          <div class="border-ui-border flex flex-row justify-between gap-3 border-y p-4">
            <template [ngTemplateOutlet]="userMenu"></template>
          </div>
          <hoc-navigation />
          <div class="grow">&nbsp;</div>
        </div>
      </div>
    }

    @if (isOffCanvasMenu) {
      <div @translateX (click)="toggleOffCanvasMenu()" class="fixed inset-0 z-40 hidden sm:block">
        <div
          class="bg-ui-surface-rise fixed inset-0 z-40 size-full sm:inset-y-0 sm:left-auto sm:right-0 sm:w-full sm:max-w-sm sm:shadow-lg"
          aria-label="Global">
          <div class="flex items-center justify-between pr-4">
            <!-- Logo area -->
            <gx-brand />
            <div class="ml-auto inline-flex items-center justify-center">
              <gx-button
                data-testid="close-menu-button"
                text="Close main menu"
                variant="neutral"
                icon="close"
                hasIcon="only"
                (click)="toggleOffCanvasMenu()" />
            </div>
          </div>
          <!-- Search area -->
          <div class="mx-4 flex flex-1"></div>
          <hoc-navigation />
          <div class="border-ui-border border-t pb-3 pt-4">
            <hoc-user-info />
            <gx-menu />
          </div>
        </div>
      </div>
    }
  </div>
}

<!-- Bottom section -->
<div class="flex min-h-0 flex-1 overflow-hidden">
  <!-- Sidebar-->
  <div class="border-ui-border bg-ui-surface-rise hidden border-r lg:block">
    <hoc-navigation />
  </div>

  <!-- Main area -->
  <main class="@container min-w-0 flex-1 flex-col md:flex">
    <gx-breadcrumbs></gx-breadcrumbs>
    <div aria-labelledby="primary-heading" class="@container flex size-full min-w-0 flex-1 lg:order-last xl:flex-row">
      <!-- TODO: if the Drawer is implemented here - we can solve probably the layout issues. -->
      <router-outlet></router-outlet>
    </div>
  </main>
</div>

<ng-template #userMenu>
  <ng-container *ngIf="{
      user: user$ | async,
      items: menuItems$ | async
      } as data; else loadingState">
    <div  *ngIf="data.user" class="flex items-center gap-3">
      <hoc-profile-image *ngIf="data.user.email" [value]="data.user.email" [profilePicture]="false" />
      <hoc-user-menu
        *ngIf="data.user.fullName"
        data-testid="header-usermenu"
        [label]="data.user.fullName + (data.user.isAdmin ? ' (A)' : '')"
        [items]="data.items ?? []"
        (navigation)="toggleOffCanvasMenu(false)"
        menuIcon="user" />
    </div>
  </ng-container>
  <ng-template #loadingState>
    <div class="flex animate-pulse items-center gap-3">
      <div class="size-8 rounded-full bg-slate-200"></div>
      <div class="h-5 w-24 rounded-md bg-slate-200"></div>
    </div>
  </ng-template>
</ng-template>

<ng-template #appearanceMenu>
  <div class="flex items-center gap-3">
    <gx-language-menu data-testid="header-language-menu" />
    <gx-theme-button data-testid="header-language-theme" />
  </div>
</ng-template>
